module.exports = {"discount":0.25,"iterations":7}


//////////////////
// WEBPACK FOOTER
// ./src/graph-config.json
// module id = 114
// module chunks = 0